var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Filter_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 30 26",
    style: {
      enableBackground: "new 0 0 30 26"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Filter_svg__st0{fill:#fff;stroke:#000;stroke-width:1.6667;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9 3.4H.8v1.5h29.1V3.4zM29.9 12.2H.8v1.5h29.1v-1.5zM29.9 21H.8v1.5h29.1V21z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Filter_svg__st0",
    d: "M24.6 9.6h-6.7v6.7h6.7V9.6zM11.4 18.6H4.7v6.7h6.7v-6.7zM11.4.8H4.7v6.7h6.7V.8z"
  })));
};
export default SvgFilter;